@if (showPopup) {
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
    (click)="onOverlayClick($event)"
    >
    <div
      #dialog
      cdkTrapFocus
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="titleId"
      tabindex="-1"
      class="relative flex flex-col max-h-[90dvh] focus:outline-hidden [@media_(height<40rem)]:py-6 px-6 py-12 md:p-12 mx-4 bg-white rounded-lg shadow-xl transform transition-all duration-300 ease-in-out"
      [class.animate-fade-in]="showPopup"
    [ngClass]="{
            'max-w-[576px]': imagePlacement === 'center',
            'max-w-[890px]': imagePlacement !== 'center',
            'w-full': config.imageModal && config.imageModal.length > 0,
          }"
      (click)="$event.stopPropagation()"
      >
      <!-- Close button -->
      <button
        type="button"
        class="absolute top-3 right-3 z-10 bg-white text-gray-400 hover:text-gray-600 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 rounded-full p-1"
        (click)="closePopup()"
        aria-label="Close popup"
        >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
      <!-- Popup content -->
      <div [className]="'flex flex-col min-h-0 overflow-y-auto md:' + flexClass"
      [ngClass]="{
            'md:flex-col': imagePlacement === 'center',
          }"
        tabindex="0"
        role="region"
        [attr.aria-label]="scrollRegionLabel">
        @if (config.imageModal && config.imageModal.length > 0) {
          <div
            class="max-w-full {{ imagePlacement === 'center' ? '' : 'md:max-w-[240px]' }} self-center md:self-start"
          [ngClass]="{
            'md:mr-12': imagePlacement === 'left',
            'md:ml-12': imagePlacement === 'right',
            '!self-center': config.bottomSectionModal !== 'button',
          }">
            <img
              class="[@media_(height<40rem)]:max-w-[200px]"
              [src]="imageUrl"
              [alt]="config.imageModal[0].altText ? config.imageModal[0].altText : ''"
              />
          </div>
        }
        <div class="grid place-items-center">
          <div class="body-modal-content">
            <div class="mb-4">
              <div [id]="titleId" class="wysiwyg mx-auto w-auto mb-2" [innerHTML]="titleHtml"></div>
              <div class="text-sm text-gray-600 wysiwyg" [innerHTML]="contentHtml"></div>
            </div>
            <!-- Action buttons -->
            @if (config.bottomSectionModal === 'button') {
              <div class="flex flex-col"
              [ngClass]="{
                'md:flex-row': imagePlacement !== 'center',
              }"
                >
                <button
                  type="button"
                  class="v-button whitespace-nowrap {{primaryButtonStyle}}"
                [ngClass]="{
                  'md:w-min': imagePlacement !== 'center',
                  '!inline': primaryButtonStyle === 'tertiary-button',
                }"
                  (click)="onPrimaryAction()"
                  [attr.aria-labelledby]="accessibilityService.getAriaLabelledby(primaryButtonText)"
                  >
                  {{ primaryButtonText }}
                  <!-- Hidden Context -->
                  <span [attr.id]="accessibilityService.getAriaLabelledby(primaryButtonText)" class="sr-only">{{accessibilityService.getAriaLabel(primaryButtonLink)}}</span>
                </button>
                <button
                  type="button"
                  class="font-bold tertiary-button self-center mt-3"
                  [ngClass]="{
                    'md:mt-0 md:ml-3': imagePlacement !== 'center',
                  }"
                  (click)="closePopup()"
                  aria-label="Close popup"
                  >
                  {{ secondaryButtonText }}
                </button>
              </div>
            }
            <!-- Capture Info -->
            @if (config.bottomSectionModal !== 'button' && !formSubmitted) {
              <div class="flex flex-col">
                <form [formGroup]="emailForm">
                  <input
                    type="text"
                    placeholder="{{placeholderInput}}"
                    class="outline-hidden h-[3.75rem] mb-2 mt-2 rounded-md p-1 pl-3 border border-gray-300 text-base mr-2 text-gray-900 w-full placeholder-gray-500 placeholder:font-light"
                    formControlName="email"
                    required
                    />
                  @if (isCaptureInfoInvalid) {
                    <p class="text-xs pb-2 text-red-600">{{ captureInfoError }}</p>
                  }
                  <!-- Try again later error message -->
                  @if (postErr) {
                    <span class="text-ace-red-600 text-xs mt-2 top-full left-0">
                      There was an issue with your subscription. Please try again later.
                    </span>
                  }
                  <button
                    type="button"
                    class="v-button w-full whitespace-nowrap {{primaryButtonStyle}}"
                    [ngClass]="{
                      '!inline': primaryButtonStyle === 'tertiary-button',
                    }"
                    (click)="submit()"
                    [attr.aria-labelledby]="accessibilityService.getAriaLabelledby(primaryButtonText)"
                    >
                    {{ primaryButtonText }}
                    <!-- Hidden Context -->
                    <span [attr.id]="accessibilityService.getAriaLabelledby(primaryButtonText)" class="sr-only">{{accessibilityService.getAriaLabel(primaryButtonLink)}}</span>
                  </button>
                </form>
              </div>
            }
            <!-- Submission Message -->
            @if (formSubmitted) {
              <div class="flex flex-col">
                <div class="text-sm text-gray-600 wysiwyg" [innerHTML]="postSubmissionMessage"></div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
